import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import Cart, { generateCartItemsFrom } from "./Cart";
// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 *
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

const Products = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [productData, updateProduct] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [productFound, setProductFound] = useState(true);
  const [timerId, udpateTimerId] = useState("");
  const token = localStorage.getItem("token");
  const [cartData, setCartData] = useState([]);
  const [cartLoad, setCartLoad] = useState(false)
  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
    try {
      setLoading(true);
      
      let response = await axios.get(`${config.endpoint}/products`);
      if (response.status === 200) {
        console.log("Data Success");
        updateProduct(response.data);
        setCartLoad(true)
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.log(error.response.data.message);
    }
  };
  useEffect(() => {
    // async function onLoad(){
    performAPICall();

    // generateCartItemsFrom(productData,cartData)
    // }
    // onLoad()
  }, []);

  useEffect(() => {
  if (cartLoad) {
    fetchCart(token);
  }
}, [cartLoad]);

  // console.log("productData", productData)

  // useEffect(() => {
  //   fetchCart(token).then((cartData) => generateCartItemsFrom(cartData, productData)).then((cartItems) => setCartData(cartItems))
  // }, [productData])

  // useEffect(() => {
  //   performSearch(searchValue);
  // }, [searchValue]);

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    try {
      setProductFound(true);
      let response = await axios
        .get(`${config.endpoint}/products/search?value=${text}`)
        .catch((e) => {
          setProductFound(false);
        });
      console.log(response.data);
      updateProduct(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const debounceSearch = (event) => {
    clearTimeout(timerId);
    const searchText = event.target.value;
    const newTimerId = setTimeout(() => performSearch(searchText), 500);
    udpateTimerId(newTimerId);
    setSearchValue(searchText); // Update searchValue immediately while debouncing
  };
  /**
   * Perform the API call to fetch the user's cart and return the response
   *
   * @param {string} token - Authentication token returned on login
   *
   * @returns { Array.<{ productId: string, qty: number }> | null }
   *    The response JSON object
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 401
   * {
   *      "success": false,
   *      "message": "Protected route, Oauth2 Bearer token not found"
   * }
   */

  const fetchCart = async (token) => {
    if (!token) return;

    try {
      let url = config.endpoint + "/cart";
      let cartDatas = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      let cartItems = generateCartItemsFrom(cartDatas.data, productData);
      setCartData(cartItems);

      return cartDatas.data;
    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar(
          "Could not fetch cart details. Check that the backend is running, reachable and returns valid JSON.",
          {
            variant: "error",
          }
        );
      }
      return null;
    }
  };

  // TODO: CRIO_TASK_MODULE_CART - Return if a product already exists in the cart
  /**
   * Return if a product already is present in the cart
   *
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { String } productId
   *    Id of a product to be checked
   *
   * @returns { Boolean }
   *    Whether a product of given "productId" exists in the "items" array
   *
   */
  const isItemInCart = (items, productId) => {
    let itemPresent = items.find((item) => item.productId === productId);

    return !!itemPresent;
  };

  /**
   * Perform the API call to add or update items in the user's cart and update local cart data to display the latest cart
   *
   * @param {string} token
   *    Authentication token returned on login
   * @param { Array.<{ productId: String, quantity: Number }> } items
   *    Array of objects with productId and quantity of products in cart
   * @param { Array.<Product> } products
   *    Array of objects with complete data on all available products
   * @param {string} productId
   *    ID of the product that is to be added or updated in cart
   * @param {number} qty
   *    How many of the product should be in the cart
   * @param {boolean} options
   *    If this function was triggered from the product card's "Add to Cart" button
   *
   * Example for successful response from backend:
   * HTTP 200 - Updated list of cart items
   * [
   *      {
   *          "productId": "KCRwjF7lN97HnEaY",
   *          "qty": 3
   *      },
   *      {
   *          "productId": "BW0jAAeDJmlZCF8i",
   *          "qty": 1
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 404 - On invalid productId
   * {
   *      "success": false,
   *      "message": "Product doesn't exist"
   * }
   */
   const  addToCart = async (
    token,
    items,
    products,
    productId,
    qty,
    check = {preventDuplicate:false}) => {
   
    if(!token){
      enqueueSnackbar("Login to add an item to the Cart",{variant:"warning"})
      return;
    }
    if(check.preventDuplicate && isItemInCart(items,productId)){
      enqueueSnackbar("Item already in Cart. Use the cart sidebar to update quantity or remove item", {variant:"error"});
      return;
    }
    
    try{
      const url = `${config.endpoint}/cart`
      const response = await axios.post(url,
        { productId,qty },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
      })
      const cartItems = generateCartItemsFrom(response.data,products);
      setCartData(cartItems)

    }catch(error){
      if(error.response){
        enqueueSnackbar(error.response.data.message,{variant:"error"})
        return null;
      }else{
        enqueueSnackbar("Could not fetch products. Check that the backend is running, reachable and returns valid JSON",{variant:"error"})
      }
    }

   };

  // const handleQuantity = async (productId, newQuantity) => {
  //   // Ensure the new quantity doesn't go below zero
  //   if (newQuantity < 0) {
  //     return;
  //   }
  
  //   try {
  //     // Make an API call to update the cart with the new quantity
  //     const response = await axios.post(
  //       `${config.endpoint}/cart`,
  //       { productId, qty: newQuantity },
  //       { headers: { Authorization: `Bearer ${token}` } }
  //     );
  
  //     if (response.status === 200) {
  //       // Update the local cart state or fetch the updated cart data
  //       fetchCart(token);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  return (
    <div>
      <Header hasHiddenAuthButtons={false}>
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}
        <TextField
          className="search-desktop"
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search color="primary" />
              </InputAdornment>
            ),
          }}
          placeholder="Search for items/categories"
          name="search"
          value={searchValue}
          onChange={debounceSearch} // Use debounceSearch here
        />
      </Header>

      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
      />
      <Grid container>
        <Grid item md={token ? 9 : 12}>
          <Grid container>
            <Grid item className="product-grid">
              <Box className="hero">
                <p className="hero-heading">
                  India’s{" "}
                  <span className="hero-highlight">FASTEST DELIVERY</span> to
                  your door step
                </p>
              </Box>
            </Grid>
          </Grid>
          {loading ? (
            <div className="circularProgress">
              <CircularProgress />
              <br />
              Loading Products
            </div>
          ) : productFound ? (
            <Grid container>
              <Grid container spacing={2}>
                {productData.map((elem) => (
                  <Grid item xs={6} md={3} lg={3}>
                    <ProductCard
                      product={elem}
                      handleAddToCart ={async()=>{
                        await addToCart(localStorage.getItem("token"),cartData,productData, elem._id,1,{preventDuplicate:true})
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          ) : (
            <div className="loading">
              <SentimentDissatisfied />
              <br />
              No Products Found
            </div>
          )}
        </Grid>
        {token && (
          <Grid item md={3} sm={12} xs={12} sx={{ backgroundColor: "#E9F5E1" }}>
            <Cart
              products={productData}
              items={cartData}
              handleQuantity={addToCart}
            />
          </Grid>
        )}
      </Grid>

      <Footer />
    </div>
  );
};

export default Products;
